export default __webpack_public_path__ + "static/media/up-arrow-black.b3614613.svg";